window.addEventListener('DOMContentLoaded', function () {
    const page = document.getElementById('js-permissions-list');
    if (!page) return;

    $(function () {
        clearFilters();
        testConfirm();
        testAlert();

        function clearFilters() {
            $('#btn_filters_clear').on('click', function (e) {
                e.preventDefault();
                $('#frm_list_filter').find("input[name='item_id']").val('');
                $('#frm_list_filter').find("input[name='item_name']").val('');
            });
        }

        function testConfirm() {
            $('#btnTestConfirm').on('click', async function () {
                let message = window.MESSAGE_SETTINGS.errors.ERR0001;
                const result = await window.showConfirm(message, 'OK', '閉じる');
                if (result) {
                    alert('OK is clicked');
                }
            });
        }

        function testAlert() {
            $('#btnTestAlert').on('click', async function () {
                await window.showAlert('削除しました。', '閉じる');
                alert('Alert closed');
            });
        }
    });
});
